import { Theme } from '../constants'

export default {

    container: {
        width: "100%",
        padding: "20px 20px 0px 20px",
        flex: "1 1 0%",
    },

    uploadContainer: {
        width: "100%",
        border: `1px dashed ${Theme.TEXT_PRIMARY}`,
        borderRadius: "12px",
        marginTop: "30px"
    },

    uploadHeader: {
        display: "flex",
        justifyContent: "space-between",
        background: "#E5EEFA",
        borderRadius: "12px 12px 0 0",
        padding: "12px 20px",
        minHeight: "51px",
        alignItems: "center",
        color: Theme.TEXT_PRIMARY_BLACK
    },

    templatesContainer:{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "15px",
    },

    downloadTemplate: {
        color: Theme.TEXT_PRIMARY,
        fontWeight: "700",
        cursor: "pointer"
    },

    uploadContainerBody: {
        minHeight: "430px",
        display: "grid",
        textAlign: "center",
        alignContent: "center",
        cursor: "pointer",
    },

    bodyContent: {
        fontSize: "16px",
        lineHeight: "21px",
        color: Theme.TEXT_PRIMARY_BLACK
    },

    headerText: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "25px",
        color: Theme.TEXT_PRIMARY_BLACK,
    },

    downloadIcon: {
        marginBottom: "4px"
    },

    supportedFormat: {
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "20px",
        color: "#676767",
    },

    fileListContainer: {
        width: "50%",
        minHeight: "50px",
        border: "1px solid black",
        alignItems: "center"
    },

    fileInput: {
        display: 'none'
    },

    fileName: {
        fontWeight: "bold",
        textDecoration: "underline",
    }

}